import { getInterestData } from './InterestService';
import { BridgingLoanDTO } from '../../Interface/Response/Interest/BridgingLoanDTO';

export const getAll = (): Promise<BridgingLoanDTO[]> => getInterestData('v1/filter/bridging-loan');

export const getFiltered = (labels: string[]): Promise<BridgingLoanDTO[]> =>
    getInterestData(`v1/filter/bridging-loan/${labels.join(',')}`);
